import React from "react";
import { IonIcon } from "@ionic/react";
import { openOutline } from "ionicons/icons";

interface FriendlyLinkProps {
  text: string;
  maxLength?: number;
}

const FriendlyLink: React.FC<FriendlyLinkProps> = ({ text, maxLength = 25 }) => {
  if (!text) return null;

  // Always prepend protocol if missing
  const href = text.startsWith("http") ? text : `https://${text}`;

  // Shorten display text
  const displayText =
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="friendly-link d-inline-flex align-items-center"
      style={{ textDecoration: "none", color: "#0d6efd" }}
    >
      <IonIcon
        icon={openOutline}
        style={{ marginRight: "6px", fontSize: "16px" }}
      />
      <span>{displayText}</span>
    </a>
  );
};

export default FriendlyLink;
